<template lang="pug">
#view_form_constancy
  v-layout
    v-flex
      h2.omnesMedium.title-constancy Mi Solicitud
  
  v-layout.form-container.pd-top
    v-flex(xs12 sm12 md12 lg12)
      h3.omnesMedium.subtitle-anulacion Anulación de póliza
      p.omnesRegular.text-anulacion
        | Al anular la póliza, su vigencia y la cobertura quedarán sin efecto. Esta decisión es irrevocable y, si el asegurado volviera a adquirir SOAT, las condiciones de la prima podrían cambiar.
      
      p.omnesRegular.text-anulacion-info
        | Por favor, selecciona el motivo de tu decisión:
      
      .endosos-style-select
        v-select.motivo-select(
          :items='cancellationReasons' 
          hide-details 
          label="Motivo de anulación" 
          required 
          v-model='localCancellationReason'
        )
      
      p.omnesRegular.text-datos-info
        | Este es el correo electrónico al que llegará tu solicitud. Si deseas realizar un cambio, ingresa a la opción
        a.link-actualizar(href="#" @click.prevent="$emit('go-to-profile')")  Actualización de datos
        | .
      
      v-text-field(
        hide-details 
        label="Correo electrónico" 
        placeholder="Cargando..."
        required 
        v-model='localEmail' 
        readonly
        outlined
      )
  
  v-layout.layout-btn-step1(row wrap)
    v-flex(xs12 sm12 md12 lg12)
      v-btn#btnSolicitud.omnesSemibold.btn-full-width(
        type='button' 
        :disabled="isDisabled" 
        @click="handleContinue"
      ) Continuar
  
  v-layout.layout-link-volver(row wrap)
    a.link-volver(href="#" @click.prevent="$emit('go-back')") Volver
</template>

<script>
/**
 * @component FormSOATCancellation
 * @description Formulario de solicitud de anulación de póliza SOAT.
 * Permite al usuario seleccionar el motivo de anulación y confirmar su correo electrónico.
 * 
 * @example
 * <FormSOATCancellation
 *   :cancellation-reasons="reasons"
 *   :cancellation-reason.sync="selectedReason"
 *   :email.sync="userEmail"
 *   :is-disabled="false"
 *   @continue="handleContinue"
 *   @go-to-profile="navigateToProfile"
 *   @go-back="goBack"
 * />
 */
export default {
  name: 'FormSOATCancellation',
  props: {
    cancellationReasons: {
      type: Array,
      required: true
    },
    cancellationReason: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    localCancellationReason: {
      get() {
        return this.cancellationReason
      },
      set(value) {
        this.$emit('update:cancellationReason', value)
      }
    },
    localEmail: {
      get() {
        return this.email
      },
      set(value) {
        this.$emit('update:email', value)
      }
    }
  },
  methods: {
    handleContinue() {
      this.$emit('continue')
    }
  }
}
</script>

<style scoped>
#view_form_constancy.lg6 {
  border: 1px solid #E7EAED;
  margin: 1em 2em;
}

#view_form_constancy.lg6 .layout.pd-lr {
  padding-left: 1.5em;
  padding-right: 1.5em;
}

#view_form_constancy.lg6 .layout.pd-top {
  padding-top: 0.5em;
}

#view_form_constancy.lg6 .layout.pd-bottom {
  padding-bottom: 0.5em;
}

#view_form_constancy .title-constancy {
  color: #0855C4;
  padding: 10px 1em;
  text-align: left;
  border-bottom: 1px solid #E7EAED;
}

.form-container {
  padding-left: 1.5em !important;
  padding-right: 1.5em !important;
}

.form-container .v-text-field,
.form-container .v-select {
  margin-bottom: 0 !important;
}

.pd-top {
  padding-top: 0.5em;
}

.subtitle-anulacion {
  color: #454A6C;
  font-size: 20px;
  margin-bottom: 16px;
  text-align: left;
  font-family: 'Omnes Medium';
}

.text-anulacion, .text-anulacion-info {
  font-size: 13px;
  color: #666;
  text-align: left;
  line-height: 1.6;
  margin-bottom: 16px;
  font-family: 'Omnes Regular';
}

.text-datos-info {
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 1.6;
  margin-top: 16px;
  margin-bottom: 16px;
  font-family: 'Omnes Regular';
}

.link-actualizar {
  color: #0855C4;
  font-weight: 600;
  text-decoration: none;
  font-family: 'Omnes SemiBold';
}

.link-actualizar:hover {
  text-decoration: underline;
}

.link-volver {
  color: #0855C4;
  font-size: 14px;
  text-decoration: none;
  text-align: center;
  display: inline-block;
  font-family: 'Omnes Medium';
  cursor: pointer;
  margin: 0;
  padding: 0;
}

.link-volver:hover {
  text-decoration: underline;
}

#view_form_constancy .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot,
#view_form_constancy .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  border: 1.2px solid #cccccc;
  padding: 5px;
  border-radius: 3px;
}

#view_form_constancy .v-text-field > .v-input__control > .v-input__slot:before,
#view_form_constancy .v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

#view_form_constancy .v-select.v-text-field .v-input__control .v-input__slot .v-select__slot label {
  top: 18px;
  left: 10px !important;
}

#view_form_constancy .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot label {
  top: 17px;
  left: 15px !important;
}

#view_form_constancy .v-select.v-text-field .v-input__control .v-input__slot .v-select__selections,
#view_form_constancy .v-input.v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 15px;
  margin-left: 10px;
}

#view_form_constancy .v-text-field {
  margin-top: 2px;
  padding-top: 2px;
  margin-bottom: 16px;
}

#view_form_constancy .v-select {
  margin-bottom: 16px;
}

button#btnSolicitud {
  font-size: 15px;
  border-radius: 4px;
  background-color: #EA0D90;
  color: #fff;
  text-transform: none;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

button#btnSolicitud:hover {
  background-color: #D10C80 !important;
}

#view_form_constancy #btnSolicitud.btn-full-width {
  width: 272px !important;
  max-width: 272px !important;
  min-width: 272px !important;
  margin: 0 auto !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 16px !important;
  height: 56px !important;
  min-height: 56px !important;
  text-align: center;
}

#btnSolicitud.btn-full-width {
  width: 272px !important;
  max-width: 272px !important;
  min-width: 272px !important;
  margin: 0 auto;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 16px !important;
  height: 56px !important;
  min-height: 56px !important;
  text-align: center;
}

#view_form_constancy .layout-btn-step1 {
  justify-content: center !important;
  align-items: center !important;
  margin-top: 24px !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
}

#view_form_constancy .layout-btn-step1 .flex {
  padding: 0 !important;
  flex: 0 0 auto !important;
}

#view_form_constancy .layout-link-volver {
  justify-content: center !important;
  align-items: center !important;
  margin-top: 12px !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
}

.layout-btn-step1 {
  justify-content: center !important;
  align-items: center !important;
  margin-top: 24px !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto !important;
  height: auto !important;
  min-height: auto !important;
}

.layout-btn-step1 .flex {
  padding: 0 !important;
  flex: 0 0 auto !important;
}

.layout-link-volver {
  justify-content: center !important;
  align-items: center !important;
  margin-top: 12px !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto !important;
  height: auto !important;
  min-height: auto !important;
}

button#btnSolicitud:disabled {
  background: #CCC !important;
  color: #999 !important;
}

button#btnSolicitud.v-btn.v-btn--disabled {
  color: #717285 !important;
}

/* SELECT ESTILO ENDOSO */
.endosos-style-select {
  margin-bottom: 20px;
}

.endosos-style-select .motivo-select .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
  margin-top: 2.6%;
}

.endosos-style-select .v-select .v-input__control .v-input__slot {
  border: 1.2px solid #cccccc;
  border-radius: 3px;
  min-height: 59px;
}

.endosos-style-select .v-select .v-input__control .v-input__slot .v-select__slot {
  padding: 0 12px;
}

.endosos-style-select .v-select .v-input__control .v-input__slot .v-select__slot .v-label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
}

.endosos-style-select .v-select.v-input--is-focused .v-input__control .v-input__slot {
  border-color: #0855C4;
}

/* Hover azul claro para las opciones del menú */
.v-list__tile.v-list__tile--link:hover {
  background-color: rgba(8, 85, 196, 0.08) !important;
}

.v-list__tile.v-list__tile--link.v-list__tile--active {
  background-color: rgba(8, 85, 196, 0.12) !important;
}

.v-list__tile.v-list__tile--link.v-list__tile--active .v-list__tile__title {
  color: #0855C4 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/soat/FormSOATCancellation.vue